<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>
<jqxWindow #windowCiudadanos [theme]="environment.tema" [position]="getFormPos(windowCiudadanos)" [zIndex]="90" [width]="1600" [height]="490"
    [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false" (onClose)="onClose()" [title]="translate('Ciudadanos')">
    <div class="formHeader" style="overflow-x: hidden;">
      {{translate('Ciudadanos')}}
    </div>
    <div class="form" style="float:left; overflow-x: hidden; ">
      <div style="float:left; margin-top: 6px; width: 100%;">
        <jqxGrid #gridCiudadanos [theme]="environment.tema" [width]="'100%'" [source]="adapterCiudadanos"
          [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
          [selectionmode]="'checkbox'" [columns]="columnsCiudadanos" [showrowlines]="false" [showcolumnlines]="true"
          [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
          [showaggregates]="true" [rowsheight]="25" [columnsheight]="25" [enabletooltips]="true" [groupable]="true"
          [editable]="false" [rowdetails]="true" [initrowdetails]="initRowDetails" [rowdetailstemplate]="rowdetailstemplate"
          (onRowclick)="onRowClick($event)" (onRowselect)="onRowSelect($event)" (onRowunselect)="onRowUnselect($event)"
          (onRowexpand)="onRowExpand($event)" (onRowdoubleclick)="onRowdoubleclick($event)">
        </jqxGrid>
      </div>
      <div style="float: left; margin-top: 6px;">
        <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='26'
          [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/mas.png"'
          [value]="translate('Crear')" (onClick)="onCrearCiudadano($event)">
        </jqxButton>
        <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='26'
          [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/editar.png"'
          [value]="translate('Editar')" (onClick)="onEditarCiudadano($event)">
        </jqxButton>
        <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='26'
          [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/borrar.png"'
          [value]="translate('Borrar')" (onClick)="onBorrarCiudadano($event)">
        </jqxButton>
      </div>
    </div>
</jqxWindow>

<div #formCiudadano></div>
